import { Briefcase, Landmark, PiggyBank, Crown } from "lucide-react";
import { CORPORATE_SOLUTIONS, CORPORATE_IMAGE } from "../lib/content";
import { QuoteForm } from "../components/QuoteForm";
import { Reveal } from "../components/Reveal";
import { usePageMeta } from "@/hooks/use-page-meta";

const ICONS = [Briefcase, Landmark, PiggyBank, Crown];

export default function Corporate() {
  usePageMeta({ title: "Kurumsal Kiralama", description: "Operasyonel kiralama, vergi avantajı, nakit akışı koruması ve VIP şoförlü hizmet ile şirketinize özel kurumsal filo çözümleri." });
  return (
    <div data-testid="corporate-page">
      <section className="py-20 px-6 border-b border-[#B09060]/20">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <div>
              <span className="text-xs font-mono-lbl uppercase tracking-widest text-[#8F7648]">
                Kurumsal
              </span>
              <h1 className="text-4xl md:text-6xl font-serif-display text-[#404040] mt-2">
                Kurumsal Çözümler
              </h1>
              <p className="text-sm text-[#6B6B6B] mt-4 leading-relaxed max-w-md">
                Şirketinizin filo ihtiyaçlarına özel çözümler: operasyonel
                kiralama modeliyle araç yatırımınızı öngörülebilir aylık
                giderlere dönüştürün.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="rounded-sm overflow-hidden border border-[#B09060]/20 h-72 md:h-96">
              <img
                src={CORPORATE_IMAGE}
                alt="Kurumsal filo çözümleri"
                className="w-full h-full object-cover"
              />
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-20 px-6 border-b border-[#B09060]/20 bg-[#F2F3EB]">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
          {CORPORATE_SOLUTIONS.map((s, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={s.title} delay={i * 0.1}>
                <div
                  className="rounded-sm bg-white shadow-[0_4px_20px_rgba(176,144,96,0.05)] border border-[#B09060]/20 p-8 h-full hover:border-[#B09060]/40 transition-colors"
                  data-testid={`corporate-solution-${i}`}
                >
                  <Icon className="w-8 h-8 text-[#8F7648]" />
                  <h3 className="text-xl font-bold text-[#404040] mt-4">{s.title}</h3>
                  <p className="text-xs text-[#555555] leading-relaxed mt-2">{s.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="py-24 px-6 bg-[#F2F3EB]">
        <div className="max-w-2xl mx-auto">
          <Reveal>
            <div className="text-center">
              <span className="text-xs font-mono-lbl uppercase tracking-widest text-[#8F7648]">
                Hemen Başlayın
              </span>
              <h2 className="text-3xl md:text-5xl font-serif-display text-[#404040] mt-2">
                Kurumsal Teklif İste
              </h2>
              <p className="text-sm text-[#6B6B6B] mt-4">
                Filo büyüklüğünüzü ve ihtiyaçlarınızı paylaşın, size özel kurumsal
                teklif hazırlayalım.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8">
              <QuoteForm formType="kurumsal" />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
